module.exports = __webpack_public_path__ + "static/media/patreon.4d68b8d6.svg";